export const TIME_FORMATS = {
  T24: {
    value: 'T24',
    pattern: 'H',
    alternatePattern: 'HH',
  },
  T12: {
    value: 'T12',
    pattern: 'h',
    alternatePattern: 'hh',
  },
}

export const TIME_TYPES = {
  future: 'future',
  past: 'past',
}
